module.exports = __webpack_public_path__ + "img/WR.8b8a1dd9.png";